export function englishList(items, def = "") {
	items = [...items];
	if (items.length === 0) return def;
	if (items.length === 1) return items[0];
	const last = items.pop();
	return `${items.join(", ")} and ${last}`;
}

export function englishPlural(n, singular, pural) {
	if (Array.isArray(n)) n = n.length;
	return n == 1 ? singular : pural;
}
